import * as Yup from 'yup'
import { resetFormatoMonto } from './Formatos';

export const validationSchemasRecuperacionCobro = (folioCartaCobro) => {
    let validation = {};

    validation.idCompaniaIM = Yup.string().required('Este campo es obligatorio.');
    validation.idSiniestroIM = Yup.string().required('Este campo es obligatorio.');
    //validation.fechaSiniestroIM = Yup.string().required('Este campo es obligatorio.');
    validation.fechaCarta = Yup.string().required('Este campo es obligatorio.');
    validation.moneda = Yup.string().required('Este campo es obligatorio.');

    validation.porcConvenio = Yup
        .string()
        .required('Este campo es obligatorio.')
        .test('mayorCien', 'El valor no puede ser mayor a 100.', value => Number(value) <= 100);

    validation.montoCosto = Yup
        .string()
        .required('Este campo es obligatorio.')
        //.test('mayorCero', 'Monto costo debe ser mayor a 0.', value => Number(resetFormatoMonto(value)) > 0)

    validation.montoRecobro = Yup
        .string()
        .required('Este campo es obligatorio.')
        .test('mayorCero', 'Monto recobro debe ser mayor a 0.', value => Number(resetFormatoMonto(value)) > 0)
        //.test('mayorCosto', 'Monto recobro debe ser menor a costo.', value => Number(resetFormatoMonto(value)) < Number(montoCosto))

    if (folioCartaCobro && folioCartaCobro > 0) {
        validation.file = Yup.mixed()
            .test('fileSize', 'Tamaño máximo del archivo 10MB.',
                (value) => {
                    if (!value) return true;
                    return value.size <= (10 * 1000000);
                })
    } else {
        validation.file = Yup.mixed().required('Este campo es obligatorio.')
        .test('fileSize', 'Tamaño máximo del archivo 10MB.',
            (value) => {
                if (!value) return true;
                return value.size <= (10 * 1000000);
            })
    }

    return Yup.object().shape(validation);
}